import { Component } from '@angular/core';

@Component({
  selector: 'msh-refunds-and-returns',
  imports: [],
  template: `
  <div class="flex justify-center">
    <div class=" max-w-[1200px] mx-12 my-12">
     <h1>Return and Refund Policy</h1>
<p>Last updated: May 17, 2026</p>
<p>Thank you for shopping at Mobile Storehouse.</p>
<p>If, for any reason, You are not completely satisfied with a purchase We invite You to review our policy on refunds and returns. This Return and Refund Policy has been created with the help of the <a href="https://www.termsfeed.com/return-refund-policy-generator/" target="_blank">Return and Refund Policy Generator</a>.</p>
<p>The following terms are applicable for any products that You purchased with Us.</p>
<h2>Interpretation and Definitions</h2>
<h3>Interpretation</h3>
<p>The words whose initial letters are capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.</p>
<h3>Definitions</h3>
<p>For the purposes of this Return and Refund Policy:</p>
<ul>
<li>
<p><strong>Company</strong> (referred to as either &quot;the Company&quot;, &quot;We&quot;, &quot;Us&quot; or &quot;Our&quot; in this Policy) refers to Mobile Storehouse.</p>
</li>
<li>
<p><strong>Goods</strong> refer to the items offered for sale on the Service.</p>
</li>
<li>
<p><strong>Orders</strong> mean a request by You to purchase Goods from Us.</p>
</li>
<li>
<p><strong>Service</strong> refers to the Website.</p>
</li>
<li>
<p><strong>Website</strong> refers to Mobile Storehouse, accessible from <a href="https://mobilestorehouse.com" rel="external nofollow noopener" target="_blank">https://mobilestorehouse.com</a>.</p>
</li>
<li>
<p><strong>Original Seller</strong> means the account accessing or using the Service, that posted the Goods for sale on the Website.</p>
</li>
<li>
<p><strong>You</strong> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.</p>
</li>
</ul>
<h2>Your Order Cancellation Rights</h2>
<p>You are entitled to cancel Your Order within 7 days without giving any reason for doing so.</p>
<p>The deadline for cancelling an Order is 7 days from the date on which You received the Goods or on which a third party you have appointed, who is not the carrier, takes possession of the product delivered.</p>
<p>In order to exercise Your right of cancellation, You must inform Us of your decision by means of a clear statement. You can inform Us of your decision by:</p>
<ul>
<li>By email: info@mobilestorehouse.com</li>
</ul>
<p>We will reimburse You no later than 14 days from the day on which We receive the returned Goods. We will use the same means of payment as You used for the Order, and You will not incur any fees for such reimbursement.</p>
<h2>Conditions for Returns</h2>
<p>In order for the Goods to be eligible for a return, please make sure that:</p>
<ul>
<li>The shipment was no marked off as arrived and complete.</li>
<li>The Goods were in the condition in which you received them.</li>
</ul>
<p>The following Goods cannot be returned:</p>
<ul>
<li>The supply of Goods were posted "as is" and the listing did not misrepresent the items in any way.</li>
<li>The supply of Goods which according to their nature are not suitable to be returned, deteriorate rapidly or where the date of expiry is over.</li>
<li>The supply of Goods which are not suitable for return due to health protection or hygiene reasons and were unsealed after delivery.</li>
<li>The supply of Goods which are, after delivery, according to their nature, inseparably mixed with other items.</li>
</ul>
<p>We may refuse returns that do not meet the conditions above, to the extent permitted by applicable law.</p>
<p>Only regular priced Goods may be refunded. Unfortunately, Goods on sale cannot be refunded. This exclusion may not apply to You if it is not permitted by applicable law.</p>
<h2>Returning Goods</h2>
<p>Before marking that the Goods have arrived and are correct they are eligible for return through the Website. In such cases, please select request refund and fill out the information.</p>

<p>Unless otherwise agreed, You are responsible for the cost and risk of returning the Goods to Us.</p>
<p>You should send the Goods back to the original seller (shipping label provided)</p>
<p>Once you have marked that the Goods arrived and are correct they are no longer eligible for return through the Website.</p>
<p>We cannot be held responsible for Goods damaged or lost in return shipment. Therefore, We recommend an insured and trackable mail service. We are unable to issue a refund without actual receipt of the Goods or proof of received return delivery.</p>
<h3>Contact Us</h3>
<p>If you have any questions about our Returns and Refunds Policy, please contact us:</p>
<ul>
<li>By email: info@mobilestorehouse.com</li>
</ul>
    </div>
  </div>
  `,
  styles: `
h1 { font-size: 2rem; margin-bottom: 26px;}  
h2 { font-size: large; margin-bottom: 13px; margin-top: 40px; color: rgb(228 129 51 / var(--tw-text-opacity, 1));}  
h3 { font-size: medium; margin-bottom: 10px; margin-top: 20px;  color: rgb(228 129 51 / var(--tw-text-opacity, 1));}  
h4 { font-size: small; margin-bottom: 10px; margin-top: 20px;  color: rgb(228 129 51 / var(--tw-text-opacity, 1));}  
p {  margin-bottom: 8px;}  
ul { margin-left: 20px; margin-bottom: 8px;}
li { margin-bottom: 4px; list-style: disc;}
`
})
export class RefundsAndReturnsComponent {

}
